import React from 'react'

const useQueueWebSocket = ({ schoolId, fractalId, setIsConnected }) => {
  const socketRef = React.useRef(null)
  const reconnectTimeoutRef = React.useRef(null)
  const isManuallyClosedRef = React.useRef(false)
  const [queues, setQueues] = React.useState([])
  const [error, setError] = React.useState(null)
  const url = `${
    process.env.REACT_APP_PROJECT_API_HOST
  }/cable?fractal_id=${fractalId}`

  const handleIsConnectAttribute = bool => {
    setIsConnected && setIsConnected(bool)
  }

  function connect () {
    try {
      socketRef.current = new WebSocket(url)
      socketRef.current.onopen = () => {
        const subscribeMessage = JSON.stringify({
          command: 'subscribe',
          identifier: JSON.stringify({
            channel: 'SchoolQueueChannel',
            school_id: schoolId
          })
        })
        socketRef.current.send(subscribeMessage)
        handleIsConnectAttribute(true)
      }
      socketRef.current.onerror = event => {
        handleIsConnectAttribute(false)
      }
      socketRef.current.onmessage = event => {
        const data = JSON.parse(event.data)
        if (data.type === 'ping') return
        if (data.message) {
          setQueues(prev => [...prev, { ...data.message }])
        }
      }

      socketRef.current.onclose = event => {
        if (!isManuallyClosedRef.current) {
          reconnectTimeoutRef.current = setTimeout(() => {
            connect()
          }, 1000)
        } else {
          socketRef.current?.close()
          handleIsConnectAttribute(false)
        }
      }
    } catch (error) {
      handleIsConnectAttribute(false)
      console.error('Erro ao conectar ao WebSocket', error)
      setError(error)
    }
  }

  React.useEffect(
    () => {
      connect()

      return () => {
        isManuallyClosedRef.current = true
        socketRef.current?.close()
        clearTimeout(reconnectTimeoutRef.current)
      }
    },
    [url]
  )
  return {
    error,
    queuesNotifications: queues,
    setQueuesNotifications: data => setQueues(data)
  }
}

export default useQueueWebSocket
